import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { homePathFor } from '../support/accountFunction';

function GuestRoute({ children }) {
  const { user, memberships, account, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center surface-page">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-slate-200 border-t-forge-600" />
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to={homePathFor(user, { memberships, account })}
        replace
      />
    );
  }

  return children;
}

export default GuestRoute;
